export default "__VITE_ASSET__wsGBNrrE__"